module.exports = __webpack_public_path__ + "static/media/how-to-start-image-2-2.00060f5e.png";